export default class OptionSearch {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.searchInput = this.DOM.el.querySelector('.search-options');
        this.DOM.optionGroups = Array.from(this.DOM.el.querySelectorAll('.option-group'));

        this.initEvents();
    }

    initEvents() {
        this.DOM.searchInput.addEventListener('input', (e) => {
            const searchTerm = e.target.value.toLowerCase();

            this.DOM.optionGroups.forEach((group) => {
                let hasVisibleItems = false;
                const items = Array.from(group.querySelectorAll('.option-item'));

                items.forEach((item) => {
                    const text = item.textContent.toLowerCase();
                    if (text.includes(searchTerm)) {
                        this.fadeIn(item);
                        hasVisibleItems = true;
                    } else {
                        this.fadeOut(item);
                    }
                });

                if (hasVisibleItems) {
                    this.fadeIn(group);
                } else {
                    this.fadeOut(group);
                }
            });

            if (searchTerm === '') {
                this.DOM.optionGroups.forEach((group) => {
                    this.fadeIn(group);
                    Array.from(group.querySelectorAll('.option-item')).forEach((item) => {
                        this.fadeIn(item);
                    });
                });
            }
        });
    }

    fadeIn(element) {
        element.style.display = 'block';
        element.style.opacity = 0;
        element.style.transition = 'opacity 0.3s ease-in-out';
        setTimeout(() => {
            element.style.opacity = 1;
        }, 10);
    }

    fadeOut(element) {
        element.style.opacity = 0;
        element.style.transition = 'opacity 0.3s ease-in-out';
        setTimeout(() => {
            element.style.display = 'none';
        }, 300);
    }
}

const searchContainer = document.querySelector('#vehicleSpecs .specs-search');
if (searchContainer) {
    new OptionSearch(searchContainer.closest('.tab-pane'));
}
